import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';
import {
  type EntityItem,
  type EntityType,
} from 'hb-react/shared/utils/entitiesContentData/types';

interface GetRecommendedContentsParams {
  contentId: number;
  contentType: EntityType;
  contentTypes?: Array<EntityType>;
  group_id?: number;
  limit: number;
  scoreThreshold: number;
}

export const getRecommendedContents = ({
  params,
  signal,
}: {
  params: GetRecommendedContentsParams;
  signal?: AbortSignal;
}) => {
  const path = Routes.private_frontoffice_ai_recommendations_path();

  return axios.get<{
    data: Array<EntityItem>;
    total: number;
  }>(path, {
    signal,
    params,
  });
};
